<template>
  <div class="row no-gutters">
    <div class="col-12 col-md-11 mx-auto d-flex flex-column text-left">
      <div class="d-flex justify-content-start">
        <ul>
          <li>將商品移往另一個分類中，左側選擇欲移動的商品，再點 移往>> 便完成移動</li>
        </ul>
        <b-form-checkbox class="border" value="accepted" unchecked-value="not_accepted">
          顯示圖檔
        </b-form-checkbox>
        <b-form-checkbox class="border" value="accepted" unchecked-value="not_accepted">
          顯示庫存量<small>(少的排前面)</small>
        </b-form-checkbox>
      </div>
      <div class="d-flex justify-content-center">
        <div class="d-flex flex-column flex-fill" style="height:600px;max-width:550px;">
          <div class="row no-gutters bg-success">
            <div class="col-12">原位置：</div>
            <div class="col-11 mx-auto d-flex">
              <select style="width:100px" class="form-control">
                <option>1</option>
                <option>2</option>
                <option>3</option>
                <option>4</option>
                <option>5</option>
              </select>
              <select style="width:100px" class="form-control">
                <option>1</option>
                <option>2</option>
                <option>3</option>
                <option>4</option>
                <option>5</option>
              </select>
            </div>
            <div class="col-11 mx-auto d-flex">
              <b-form-checkbox value="accepted" unchecked-value="not_accepted">
                上架商品
              </b-form-checkbox>
              <b-form-checkbox value="accepted" unchecked-value="not_accepted">
                下架商品
              </b-form-checkbox>
            </div>
            <div class="col-11 mx-auto d-flex">
              <div class="d-flex align-items-center flex-fill">
                <div class="d-flex">
                  <select class="custom-select">
                    <option selected>商品代碼</option>
                  </select>
                </div>
                <div>
                  <b-form-input size="sm"></b-form-input>
                </div>
                <div class="d-flex flex-column align-items-start">
                  <b-form-radio name="proClassRadio" value="A">所有分類</b-form-radio>
                  <b-form-radio name="proClassRadio" value="B">僅於此分類內</b-form-radio>
                </div>
                <button type="button" class="btn btn-primary">查詢</button>
              </div>
            </div>
          </div>
          <div class="d-flex flex-column flex-fill bg-warning overflow-auto" style="">
            <div class="align-self-center">共{{}}筆</div>
            <div class="d-flex">
              <div><img src="" alt="圖片" /></div>
              <div>
                <b-form-checkbox value="accepted" unchecked-value="not_accepted"> </b-form-checkbox>
              </div>
              <div>(同右) 課程 / 0A0001 MAC Pro</div>
            </div>
          </div>
        </div>
        <div class="d-flex flex-column align-items-center align-self-center">
          <div>
            <button type="button" class="btn btn-primary">移往>>></button>
          </div>
          <div>移動後排序</div>
          <div>
            <b-form-radio name="proClassSortRadio" value="A">放前面</b-form-radio>
          </div>
          <div>
            <b-form-radio name="proClassSortRadio" value="B">放後面</b-form-radio>
          </div>
        </div>
        <div class="d-flex flex-column flex-fill" style="height:600px;max-width:550px">
          <div class="d-flex flex-column bg-success">
            <div>目的位置：</div>
            <div class="d-flex align-self-center">
              <select style="width:100px" class="form-control">
                <option>1</option>
                <option>2</option>
                <option>3</option>
                <option>4</option>
                <option>5</option>
              </select>
              <select style="width:100px" class="form-control">
                <option>1</option>
                <option>2</option>
                <option>3</option>
                <option>4</option>
                <option>5</option>
              </select>
            </div>
          </div>
          <div class="d-flex flex-column flex-fill overflow-auto bg-warning" style="">
            <div class="align-self-center">共{{}}筆</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      num: 10,
    };
  },
};
</script>

<style></style>
